exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row {\n    background-color: #F0F0F0;\n    padding: 10px 10px 10px 20px;\n}\n\nth {\n    background-color: #12408B;\n    color: #FFFFFF;\n    font-size: 13px;\n}\n\ntr:nth-child(even) {\n    background-color: #FFFFFF;\n}\n\ntr:hover {\n    background-color: #CCCCCC !important;\n    color: #212121 !important;\n}\n\ntd {\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-right: 1px solid #FFFFFF;\n}\n::ng-deep .modal-body.popup-prop {\n    background-color: #f7f6f2;\n    padding-left: 35px;\n}\n\n.message-popup {\n    width: 100%;\n    min-height: 45px;\n    font-family: MaerskCustomFontForDigitZero-Regular,MaerskText-Regular;\n    color: black;\n    font-size: 13px;\n    margin: 0;\n    padding: 10px;\n    height: 95%;\n}\n\n::ng-deep .message-popup .message-content {\n    /* margin: 0;*/\n    margin-left: 75px;\n    padding: 10px;\n    height: 90%;\n    overflow: auto;\n    overflow-x: hidden;\n    font-size: medium;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/help-popup/help-popup.component.css
// module id = ../../../../../src/app/layout/home/help-popup/help-popup.component.css
// module chunks = main